module.exports = "/images/default-project-image.png?c6f881ef9f18d5c66d0f43b0607728e1";